import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './button.scss';

const buttonVariants = cva('button', {
    variants: {
        variant: {
            default: 'button--default',
            secondary: 'button--secondary',
            tertiary: 'button--tertiary',
            coupon: 'button--coupon',
            ghost: 'button--ghost',
            outlined: 'button--outlined',
        },
        size: {
            icon: 'button--icon',
            small: 'button--small',
            default: 'button--default',
            large: 'button--large',
            huge: 'button--huge',
        },
        orientation: {
            vertical: 'button--vertical',
            horizontal: 'button--horizontal',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
        orientation: 'horizontal',
    },
});

type Props = ComponentPropsWithRef<'button'> &
    VariantProps<typeof buttonVariants> & {
        asChild?: boolean;
    };
export const Button = ({
    className,
    variant = 'default',
    size = 'default',
    orientation = 'horizontal',
    asChild = false,
    ...props
}: Props) => {
    const Comp = asChild ? Slot : 'button';

    return (
        <Comp
            data-variant={variant}
            data-size={size}
            data-orientation={orientation}
            className={cn(buttonVariants({ variant, size, orientation, className }))}
            type="button"
            {...props}
        />
    );
};
